import {buildTtaSave, TransportAssocEntity,} from "@ots-frontend/ots-data";
import {useCallback} from "react";
import {useTtaMutation} from "../../../hooks/useTtaMutation";
import {useDownloadTicketPdf} from "../../../hooks/useDownloadTicketPdf";
import {useNavigate} from "react-router-dom";
import {useApp} from "../../../providers/RegionProvider/RegionProvider";
import {TicketAction} from "./TicketActionMenu";

export type UseTicketActionProps = {}

export type UseTicketActionResult = {
  onTicketActionClick: (ticket: TransportAssocEntity, action: TicketAction) => void;
}

export const useTicketAction = (props: UseTicketActionProps = {}): UseTicketActionResult => {
  const {} = props

  const {baseQueryApi} = useApp()
  const navigate = useNavigate();

  const {
    dispatchValidate,
    deleteTta,
    deleteTtaAll,
    saveTta,
  } = useTtaMutation()

  const {
    downloadTicketPdf,
  } = useDownloadTicketPdf({baseQueryApi})

  const _onTicketActionClick = useCallback((ticket: TransportAssocEntity, action: TicketAction) => {
    if (action === "DOWNLOAD") {
      downloadTicketPdf(ticket, undefined)
    } else if (action === "EDIT") {
      navigate(`/tickets/form`, {state: {id: ticket.id, database: ticket.database}})
    } else if (action === "TOGGLE_DISPATCH_VALIDATION") {
      dispatchValidate(ticket, !ticket.dispatchValidatedDttm, undefined)
    } else if (action === "TOGGLE_PICKUP_DEMURRAGE" && ticket.pickupTransport) {
      const update = buildTtaSave(ticket)
      saveTta({
        ...update,
        pickupTransport: {
          ...update.pickupTransport,
          disableDemurrage: !ticket.pickupTransport.disableDemurrage,
        }
      }, undefined)
    } else if (action === "TOGGLE_DELIVERY_DEMURRAGE" && ticket.deliveryTransport) {
      const update = buildTtaSave(ticket)
      saveTta({
        ...update,
        deliveryTransport: {
          ...update.deliveryTransport,
          disableDemurrage: !ticket.deliveryTransport.disableDemurrage,
        }
      }, undefined)
    } else if (action === "DELETE") {
      deleteTtaAll(ticket.id, undefined)
    } else if (action === "DELETE_ASSOC") {
      deleteTta(ticket.id, undefined)
    }
  }, [navigate, downloadTicketPdf, dispatchValidate, deleteTta, deleteTtaAll, saveTta])

  return {
    onTicketActionClick: _onTicketActionClick
  }
}
